import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="marketing" routeLang="en" />;

export const Route = createFileRoute("/en/marketing")({
  head: () => publicToolHead("marketing", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
